import { useSearchParams } from 'react-router-dom';
import { PATHS } from '../../constants/Paths.constants';
import Logo from '..//../assets/report-logo.svg';
import { Tab, TermsAndPrivacyTabProps } from './TermsAndPrivacy.types';

export function TermsAndPrivacyTab({
  activeTab,
  setActiveTab,
}: TermsAndPrivacyTabProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs: Tab[] = [
    {
      key: 'terms',
      name: 'Terms and Conditions',
    },
    {
      key: 'policy',
      name: 'Privacy Policy',
    },
  ];

  const handleClick = (tabKey: 'terms' | 'policy') => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  return (
    <div className="h-16 flex gap-10 items-center">
      <a href={PATHS.REGISTRATION}>
        <img src={Logo} alt="Logo" />
      </a>
      <div className="flex gap-10">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleClick(tab.key)}
            className={`font-medium transition-all duration-50 ${
              activeTab === tab.key ? 'text-gray-900' : 'text-sm text-gray-550'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  );
}
